define('views/components/action_history/action_history',['require','backbone','text!templates/components/action_history/action_history.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/action_history/action_history.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'action-history-item'
    });
});
